import { PhishingSimulationVector } from '@/types/phishingSimulations'
import { EMAIL_MICRO_TRAINING_DINDINGS, SMS_MICRO_TRAINING_DINDINGS } from '../constants/micro-training'

export interface Findings {
  title: string
  description: string
  command: string
}

const getRandomItem = (arr: Findings[]): Findings => {
  const randomIndex = Math.floor(Math.random() * arr.length)
  return arr[randomIndex]
}

export const getItemsForDifficulty = (difficulty: number, vectorType: string): Findings[] => {
  const results: Findings[] = []
  const findingsOptions: any =
    vectorType === PhishingSimulationVector.Email ? EMAIL_MICRO_TRAINING_DINDINGS : SMS_MICRO_TRAINING_DINDINGS
  for (let i = difficulty; i < 5; i++) {
    if (findingsOptions[i] && findingsOptions[i].length) {
      const item = getRandomItem(findingsOptions[i])
      results.push(item)
    }
  }

  return results
}
export const generateFindingsForSelectedItems = (selectedItems: Findings[]): string => {
  let findings = ''
  let findingCounter = 1

  for (const item of selectedItems) {
    if (item.command) {
      findings += `\n    - ${item.command}. Critical! Add it to the email body with <span id=finding${findingCounter}></span> around it`
      findingCounter++
    }
  }

  return findings
}
